"use client";

import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const DEFAULT_CLIENT_ID = "998473765583-ram81h9jtdk5cg2vt1lbv60msffdl5in.apps.googleusercontent.com";

export default function GoogleAuthProvider({ children }: { children: React.ReactNode }) {
  const clientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || DEFAULT_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={clientId}>
      {children}
    </GoogleOAuthProvider>
  );
}
